import React from 'react';
import { Outlet } from 'react-router-dom';
import VideoPressSidebar from '@/components/video-press/VideoPressSidebar';

const VideoPressLayout: React.FC = () => {
  return (
    <div className="flex w-full bg-gray-50">
      <VideoPressSidebar />
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default VideoPressLayout;